export const FBErrorConnector = () => {
  return <div>Error</div>;
};
